export default "__VITE_ASSET__CEOJk$z2__"